import React, { useState } from "react";
import NoSearchitems from "../../components/NoSearchitems";
import EmiModal from "./EmiModal";

function OrderLoanTable({
  orderItems,
  totalPercentage,
  totalPledgedValue,
  initialPledgedValue,
}) {
  function truncateText(text, maxLength = 40) {
    if (text === null || text === undefined) return "--";
    if (text?.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }
  function replaceUnderscores(text) {
    if (text === null || text === undefined) return "--";
    return text.replace(/_/g, " ");
  }

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  return (
    <>
      <div className=" rounded border border=[#e2ecff] mt-4  overflow-auto">
        <table className="w-full min-w-[1160px] box-border  flex flex-col mt-4 rounded ">
          <thead className="text-xs font-semibold">
            <tr className="w-full flex items-center">
              <th className="text-left pl-6  pt-1 pb-3 w-[13%] flex flex-col">
                Pledge<span> Reference No.</span>
              </th>
              <th className={`text-left  w-[16%]`}>Constituents</th>

              <th className="text-left  w-[11%]">Repository</th>
              <th className={`text-left w-[6%] `}>LTV(%)</th>
              <th className={`text-left w-[8%] mr-5  `}>
                Initial Pledged Unit Price
              </th>

              <th className={`text-left w-[9%] `}>Pledged Unit</th>
              <th className={`text-left w-[11%] mr-2`}>
                Initial Pledged Asset Value
              </th>
              <th className={`text-left w-[11%] mr-2`}>
                Current Pledged Unit Price
              </th>
              <th className={`text-left w-[12%] `}>
                Current Pledged Asset Value
              </th>
            </tr>
          </thead>

          <tbody className={`   ${orderItems?.length === 0 ? " " : ""}`}>
            {orderItems?.length === 0 && (
              <>
                <NoSearchitems />
              </>
            )}
            {orderItems?.map((data, index) => (
              <tr
                className={`text-xs font-medium w-full flex items-center  h-[60px] ${
                  index % 2 === 0 ? "bg-[#f8f8f8]" : "bg-white"
                }`}
              >
                <td className="text-left pl-6   w-[13%]">
                  {data.pledged_reference_number || "--"}
                </td>
                <td
                  className={`text-left w-[16%] pt-3 pb-2 pr-6`}
                  title={data.consituents}
                >
                  {truncateText(data.consituents, 57)}
                </td>
                <td className="text-left  w-[11%]">
                  {" "}
                  {`${data.repository}/${replaceUnderscores(
                    data.pledged_status
                  )}`}
                </td>
                <td className={`text-left w-[6%] `}>{data.ltv}</td>
                <td className={`text-left w-[8%] mr-5 `}>
                  {formatToIndianRupees(data.initial_pledge_unit_price)}
                </td>

                <td className={`text-left w-[9%] `}>
                  {data.pledged_unit || "--"}
                </td>
                <td className={`text-left w-[11%] mr-2`}>
                  {data.initial_pledged_asset_value
                    ? formatToIndianRupees(data.initial_pledged_asset_value)
                    : "--"}
                </td>
                <td className={`text-left w-[11%] mr-2`}>
                  {data.current_pledged_unit_price
                    ? formatToIndianRupees(data.current_pledged_unit_price)
                    : "--"}
                  <span
                    className={`ml-1 ${
                      data.current_pledged_unit_price_percentage < 0
                        ? "text-[#d30000] "
                        : "text-[#0ba300]"
                    }`}
                  >
                    {data.current_pledged_unit_price_percentage !== null
                      ? `(${data.current_pledged_unit_price_percentage}%)`
                      : ""}
                  </span>
                </td>
                <td className={`text-left w-[12%]`}>
                  {data.current_pledged_asset_value
                    ? formatToIndianRupees(data.current_pledged_asset_value)
                    : "--"}
                  <span
                    className={`ml-1 ${
                      data.current_pledged_asset_value_percentage < 0
                        ? "text-[#d30000] "
                        : "text-[#0ba300]"
                    }`}
                  >
                    {data.current_pledged_asset_value_percentage !== null
                      ? `(${data.current_pledged_asset_value_percentage}%)`
                      : ""}
                  </span>
                </td>
              </tr>
            ))}
            <tr
              className={`text-xs  font-bold w-full flex items-center  h-[60px] bg-[#e6ebed]`}
            >
              <td className="text-left pl-6   w-[13%]">Total</td>
              <td className={`text-left w-[16%] pt-3 pb-2`}></td>
              <td className="text-left  w-[11%]"> </td>
              <td className={`text-left w-[6%] `}> </td>
              <td className={`text-left w-[8%] mr-5 `}> </td>

              <td className={`text-left w-[9%] `}></td>
              <td className={`text-left w-[11%] mr-2`}>
                {formatToIndianRupees(initialPledgedValue)}
              </td>
              <td className={`text-left w-[11%] mr-2`}></td>
              <td className={`text-left w-[12%]`}>
                {formatToIndianRupees(totalPledgedValue)}{" "}
                <span
                  className={`ml-1 ${
                    totalPercentage < 0 ? "text-[#d30000] " : "text-[#0ba300]"
                  }`}
                >
                  {" "}
                  {totalPercentage !== null
                    ? `(${totalPercentage?.toFixed(2)}%)`
                    : ""}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default OrderLoanTable;
